import { Pipe, PipeTransform } from '@angular/core';

import { TimesheetStatusEnum } from '@shared-enums/time.enum';

@Pipe({
  name: 'status',
  standalone: false,
})
export class StatusPipe implements PipeTransform {
  transform<T>(value: T): string {
    if (typeof value === 'string') {
      const upper = value.toUpperCase() as TimesheetStatusEnum;
      if (upper === TimesheetStatusEnum.Created) return 'Created';
      if (upper === TimesheetStatusEnum.InProgress) return 'In Progress';
      if (upper === TimesheetStatusEnum.PayrollApproved) return 'Payroll Approved';
      if (upper === TimesheetStatusEnum.BillingApproved) return 'Billing Approved';
      return value;
    }
    return '';
  }
}
